export const sortObject = <V>(original: Record<string, V>): void => {
  Object.keys(original)
    .sort((a, b) => a.localeCompare(b))
    .forEach((key) => {
      const val = original[key];
      // eslint-disable-next-line no-param-reassign
      delete original[key];
      // eslint-disable-next-line no-param-reassign
      original[key] = val;
    });
};
